/* ==========================================================================
   Grandeur Community — storefront behaviour (no dependencies)
   Feed: grid/feed views, infinite scroll (Section Rendering API), post viewer
   modal, likes (optimistic), share sheet, composer with crop + upload,
   native blog comments posted via fetch, delete own post/comment.
   ========================================================================== */
(() => {
  'use strict';
  if (window.__grandeurCommunity) return;
  window.__grandeurCommunity = true;

  /* ---------- config / session ---------- */
  const CFG = { api: '', blogUrl: '/blogs/community', loginUrl: '/account/login', moderated: false, commentsEnabled: true, customer: null };
  const cfgEl = document.getElementById('cm-config');
  if (cfgEl) { try { Object.assign(CFG, JSON.parse(cfgEl.textContent || '{}')); } catch (e) { /* ignore */ } }
  const feedEl = document.getElementById('cm-feed');
  if (feedEl && feedEl.dataset.cmDebugSession) { try { CFG.customer = JSON.parse(feedEl.dataset.cmDebugSession); } catch (e) { /* ignore */ } }
  // Dev hook: a test session in localStorage (the backend still verifies the HMAC token, so this grants nothing by itself).
  try { const dbg = localStorage.getItem('cm-debug-session'); if (dbg) CFG.customer = JSON.parse(dbg); } catch (e) { /* ignore */ }
  const API = String(CFG.api || '').replace(/\/+$/, '') + '/api/community';
  const S = {
    liked: new Set(((CFG.customer && CFG.customer.liked) || []).map(String)),
    busy: new Set(), pushed: false, loadingMore: false, lastTap: 0, tapTimer: null, tapId: null,
  };

  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const loggedIn = () => !!(CFG.customer && CFG.customer.token);

  /* ---------- toast ---------- */
  let toastTimer = null;
  function toast(msg, kind) {
    let el = $('#cm-toast');
    if (!el) { el = document.createElement('div'); el.id = 'cm-toast'; el.className = 'cm-toast'; document.body.appendChild(el); }
    el.textContent = msg; el.classList.toggle('is-error', kind === 'error'); el.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(() => { el.hidden = true; }, 2800);
  }

  /* ---------- API ---------- */
  async function api(path, opts = {}) {
    const headers = { 'X-Community-Token': (CFG.customer && CFG.customer.token) || '' };
    let body = opts.form;
    if (!body && opts.body) { headers['Content-Type'] = 'application/json'; body = JSON.stringify(opts.body); }
    let res;
    try { res = await fetch(API + path, { method: opts.method || 'GET', headers, body, mode: 'cors' }); }
    catch (e) { throw new Error('Network error — please check your connection'); }
    let data = null; try { data = await res.json(); } catch (e) { /* not json */ }
    if (!res.ok || !data || data.ok === false) {
      const code = data && data.error;
      if (code === 'session_expired') { toast('Session expired — refreshing…'); setTimeout(() => location.reload(), 1200); }
      else if (code === 'login_required') requireLogin();
      throw new Error((data && data.message) || `Request failed (${res.status})`);
    }
    return data;
  }
  async function fetchText(url) {
    const res = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.text();
  }

  /* ---------- login gate ---------- */
  function requireLogin() {
    if (loggedIn()) return true;
    const dlg = $('#cm-login');
    if (dlg && typeof dlg.showModal === 'function') { const a = $('[data-cm-login-link]', dlg); if (a && CFG.loginUrl) a.href = CFG.loginUrl; if (!dlg.open) dlg.showModal(); }
    else location.href = CFG.loginUrl;
    return false;
  }

  /* ---------- time ago ---------- */
  function ago(unix) {
    const d = Date.now() / 1000 - unix;
    if (d < 45) return 'now';
    if (d < 3600) return `${Math.floor(d / 60)}m`;
    if (d < 86400) return `${Math.floor(d / 3600)}h`;
    if (d < 7 * 86400) return `${Math.floor(d / 86400)}d`;
    if (d < 30 * 86400) return `${Math.floor(d / 604800)}w`;
    const dt = new Date(unix * 1000);
    const opts = { month: 'short', day: 'numeric' };
    if (dt.getFullYear() !== new Date().getFullYear()) opts.year = 'numeric';
    return dt.toLocaleDateString(undefined, opts);
  }
  function refreshTimes(root) { $$('[data-cm-ago]', root).forEach((el) => { const t = Number(el.dataset.cmAgo); if (t) el.textContent = ago(t); }); }

  /* ---------- likes ---------- */
  function applyLike(id, liked, count) {
    S.liked[liked ? 'add' : 'delete'](String(id));
    $$(`[data-id="${id}"]`).forEach((el) => {
      el.dataset.liked = String(liked);
      $$('[data-cm-like]', el).forEach((b) => b.setAttribute('aria-pressed', String(liked)));
      if (count != null) {
        el.dataset.likes = String(count);
        $$('[data-cm-like-count]', el).forEach((n) => { n.textContent = String(count); });
        $$('[data-cm-like-word]', el).forEach((n) => { n.textContent = count === 1 ? 'like' : 'likes'; });
        const likesP = $('.cm-card__likes', el);
        if (likesP && !$('[data-cm-like-word]', likesP)) likesP.innerHTML = `<b data-cm-like-count>${count}</b> ${count === 1 ? 'like' : 'likes'}`;
      }
    });
  }
  function burst(id) {
    $$(`[data-id="${id}"] .cm-burst`).forEach((b) => { b.classList.remove('is-on'); void b.offsetWidth; b.classList.add('is-on'); setTimeout(() => b.classList.remove('is-on'), 950); });
  }
  async function toggleLike(id, onlyLike) {
    id = String(id);
    if (!requireLogin()) return;
    const cur = S.liked.has(id);
    if (onlyLike && cur) { burst(id); return; }
    if (S.busy.has(id)) return;
    S.busy.add(id);
    const el = $(`[data-id="${id}"]`);
    const base = Number((el && el.dataset.likes) || 0);
    const next = !cur;
    applyLike(id, next, Math.max(0, base + (next ? 1 : -1)));
    if (next) burst(id);
    try { const r = await api(`/posts/${id}/like`, { method: 'POST' }); applyLike(id, r.liked, r.count); }
    catch (e) { applyLike(id, cur, base); if (loggedIn()) toast(e.message || 'Could not update like', 'error'); }
    finally { S.busy.delete(id); }
  }
  function syncLikes(root) {
    const nodes = $$('.cm-card, .cm-post', root);
    if (root && root.matches && root.matches('.cm-card, .cm-post')) nodes.push(root);
    nodes.forEach((el) => { const id = el.dataset.id; if (S.liked.has(id) && el.dataset.liked !== 'true') applyLike(id, true, null); });
  }

  /* ---------- share ---------- */
  async function share(url, title) {
    const abs = new URL(url || location.pathname, location.origin).toString();
    if (navigator.share) {
      try { await navigator.share({ title: title || document.title, url: abs }); return; }
      catch (e) { if (e && e.name === 'AbortError') return; }
    }
    openShareSheet(abs, title);
  }
  function openShareSheet(abs, title) {
    const dlg = $('#cm-share');
    if (!dlg || typeof dlg.showModal !== 'function') { copyText(abs); return; }
    const t = encodeURIComponent(title || 'Grandeur Community'); const u = encodeURIComponent(abs);
    const set = (k, href) => { const a = $(`[data-cm-share-to="${k}"]`, dlg); if (a) a.href = href; };
    set('whatsapp', `https://wa.me/?text=${t}%20${u}`);
    set('x', `https://twitter.com/intent/tweet?text=${t}&url=${u}`);
    set('facebook', `https://www.facebook.com/sharer/sharer.php?u=${u}`);
    set('email', `mailto:?subject=${t}&body=${u}`);
    const p = $('[data-cm-share-url]', dlg); if (p) p.textContent = abs;
    dlg.dataset.url = abs;
    if (!dlg.open) dlg.showModal();
  }
  async function copyText(text) {
    try { await navigator.clipboard.writeText(text); toast('Link copied'); }
    catch (e) { const ta = document.createElement('textarea'); ta.value = text; document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); toast('Link copied'); } catch (e2) { toast(text); } ta.remove(); }
  }

  /* ---------- post viewer ---------- */
  const SKELETON = '<div class="cm-skeleton"><span class="cm-loader"><svg class="cm-i cm-i--spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M21 12a9 9 0 1 1-6.2-8.6"/></svg></span></div>';
  function lockScroll(on) { document.documentElement.classList.toggle('cm-lock', !!on); }

  async function openPost(url, opts = {}) {
    const dlg = $('#cm-post-dialog');
    if (!dlg || typeof dlg.showModal !== 'function') { location.href = url; return; }
    const body = $('#cm-post-dialog-body');
    body.innerHTML = SKELETON;
    if (!dlg.open) dlg.showModal();
    lockScroll(true);
    if (!opts.fromHistory) { try { history.pushState({ cmPost: url }, '', url); S.pushed = true; } catch (e) { /* ignore */ } }
    try {
      const html = await fetchText(url + (url.includes('?') ? '&' : '?') + 'section_id=community-post');
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const post = doc.querySelector('#cm-post');
      if (!post) throw new Error('missing');
      body.innerHTML = '';
      body.appendChild(document.adoptNode(post));
      bindPost(post);
      refreshTimes(post);
      syncLikes(post);
      const ta = $('#cm-comment-form textarea', post);
      if (opts.focusComment && ta) setTimeout(() => ta.focus(), 50);
    } catch (e) {
      body.innerHTML = `<div class="cm-skeleton"><p>Couldn't load this post.</p><a class="cm-btn cm-btn--ghost" href="${esc(url)}">Open post page</a></div>`;
    }
  }
  function closePost() { const dlg = $('#cm-post-dialog'); if (dlg && dlg.open) dlg.close(); }

  /* ---------- infinite scroll + feed reload ---------- */
  function setLoader(on) { const l = $('.cm-sentinel .cm-loader'); if (l) l.hidden = !on; }
  function setupInfinite() {
    const sentinel = $('[data-cm-sentinel]'); const list = $('#cm-list');
    if (!sentinel || !list || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(async (entries) => {
      if (!entries.some((e) => e.isIntersecting) || S.loadingMore) return;
      const next = $('[data-cm-next]', list); if (!next) return;
      S.loadingMore = true; setLoader(true);
      try {
        const url = new URL(next.getAttribute('href'), location.origin);
        url.searchParams.set('section_id', 'community-feed');
        const doc = new DOMParser().parseFromString(await fetchText(url.toString()), 'text/html');
        const cards = doc.querySelectorAll('#cm-list .cm-card');
        const newNext = doc.querySelector('#cm-list [data-cm-next]');
        next.remove();
        cards.forEach((c) => list.appendChild(document.adoptNode(c)));
        if (newNext) list.appendChild(document.adoptNode(newNext));
        refreshTimes(list); syncLikes(list); initCaptions(list);
      } catch (e) { toast('Could not load more posts', 'error'); }
      finally { S.loadingMore = false; setLoader(false); }
    }, { rootMargin: '700px 0px' });
    io.observe(sentinel);
  }
  function cardFromPost(post) {
    const el = document.createElement('article');
    el.className = 'cm-card';
    el.dataset.id = String(post.id); el.dataset.handle = post.handle || ''; el.dataset.url = post.url; el.dataset.title = post.title || '';
    el.dataset.likes = '0'; el.dataset.liked = 'false'; el.dataset.comments = '0';
    const name = esc(post.author || (CFG.customer && CFG.customer.name) || 'You');
    const img = post.imageUrl ? `<img src="${esc(post.imageUrl)}" alt="${esc(post.title || '')}" loading="eager">` : '';
    el.innerHTML = `<header class="cm-card__head"><span class="cm-avatar" aria-hidden="true">${name[0].toUpperCase()}</span><div class="cm-card__meta"><span class="cm-card__author">${name}</span>${post.watchModel ? `<span class="cm-card__model">${esc(post.watchModel)}</span>` : ''}</div><time class="cm-card__time">now</time></header>
<a class="cm-card__media" href="${esc(post.url)}" data-cm-open>${img}<span class="cm-card__overlay" aria-hidden="true"></span><span class="cm-burst" aria-hidden="true"></span></a>
<div class="cm-card__actions"><button type="button" class="cm-act cm-act--like" data-cm-like aria-pressed="false" aria-label="Like"><svg class="cm-i cm-i--heart" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg><svg class="cm-i cm-i--heart-fill" viewBox="0 0 24 24" fill="currentColor"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg></button><button type="button" class="cm-act" data-cm-open aria-label="Comments"><svg class="cm-i" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg></button><button type="button" class="cm-act" data-cm-share aria-label="Share"><svg class="cm-i" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M22 2L11 13"/><path d="M22 2l-7 20-4-9-9-4 20-7z"/></svg></button></div>
<p class="cm-card__likes"><b data-cm-like-count>0</b> likes</p>
${post.caption ? `<div class="cm-card__caption" data-cm-caption><b class="cm-card__caption-author">${name}</b> <span class="cm-card__caption-text">${esc(post.caption)}</span><button type="button" class="cm-card__more" data-cm-more>more</button></div>` : ''}
<a class="cm-card__comments" href="${esc(post.url)}" data-cm-open>Add a comment…</a>`;
    return el;
  }
  async function reloadFeed(opts = {}) {
    const list = $('#cm-list');
    if (!list) { location.href = CFG.blogUrl; return; }
    const fresh = async () => {
      const url = new URL(CFG.blogUrl, location.origin);
      url.searchParams.set('section_id', 'community-feed');
      url.searchParams.set('_cm', String(Date.now()));   // skip Shopify's short edge cache
      const doc = new DOMParser().parseFromString(await fetchText(url.toString()), 'text/html');
      return doc.querySelector('#cm-list');
    };
    try {
      let node = await fresh();
      if (!node) throw new Error('no list');
      const expect = opts.post && String(opts.post.id);
      if (expect && !node.querySelector(`.cm-card[data-id="${expect}"]`)) {
        await new Promise((r) => setTimeout(r, 1500));
        node = (await fresh()) || node;
      }
      list.innerHTML = node.innerHTML;
      if (expect && !list.querySelector(`.cm-card[data-id="${expect}"]`)) list.prepend(cardFromPost(opts.post));
      const empty = $('.cm-empty'); if (empty) empty.remove();
      refreshTimes(list); syncLikes(list); initCaptions(list);
      if (location.pathname !== CFG.blogUrl) history.replaceState(null, '', CFG.blogUrl);
      window.scrollTo({ top: Math.max(0, (feedEl ? feedEl.getBoundingClientRect().top + window.scrollY : 0) - 20), behavior: 'smooth' });
    } catch (e) { location.href = CFG.blogUrl; }
  }

  /* ---------- captions ---------- */
  function initCaptions(root) {
    $$('[data-cm-caption]', root).forEach((cap) => {
      const text = $('.cm-card__caption-text', cap); if (!text) return;
      cap.classList.toggle('has-more', text.scrollHeight > text.clientHeight + 2);
    });
  }

  /* ---------- views ---------- */
  function setView(v, persist) {
    if (!feedEl) return;
    feedEl.dataset.view = v;
    $$('[data-cm-view]').forEach((b) => b.classList.toggle('is-active', b.dataset.cmView === v));
    if (persist) { try { localStorage.setItem('cm-view', v); } catch (e) { /* ignore */ } }
    initCaptions(feedEl);
  }

  /* ---------- composer ---------- */
  const C = { file: null, img: null, url: null, aspect: '1:1', fx: 0.5, fy: 0.5, w: 0, h: 0, uploading: false };
  function composer() { return $('#cm-composer'); }
  function openComposer() {
    if (!requireLogin()) return;
    const dlg = composer();
    if (!dlg || typeof dlg.showModal !== 'function') { location.href = CFG.blogUrl + '#share'; return; }
    resetComposer();
    const name = $('[data-cm-me-name]', dlg); if (name && CFG.customer && CFG.customer.name) name.textContent = CFG.customer.name;
    if (!dlg.open) dlg.showModal();
    lockScroll(true);
  }
  function resetComposer() {
    const dlg = composer(); if (!dlg) return;
    if (C.url) URL.revokeObjectURL(C.url);
    Object.assign(C, { file: null, img: null, url: null, aspect: '1:1', fx: 0.5, fy: 0.5, w: 0, h: 0, uploading: false });
    showStep('pick');
    const f = $('#cm-file', dlg); if (f) f.value = '';
    const cap = $('#cm-caption', dlg); if (cap) cap.value = '';
    const cnt = $('[data-cm-count]', dlg); if (cnt) cnt.textContent = '0';
    const sel = $('#cm-model', dlg); if (sel) sel.value = '';
    const other = $('[data-cm-other]', dlg); if (other) other.hidden = true;
    setError('');
    setProgress(null);
    const btn = $('#cm-submit', dlg); if (btn) { btn.disabled = false; btn.textContent = 'Share'; }
    setAspect('1:1');
  }
  function showStep(step) {
    const dlg = composer(); if (!dlg) return;
    $$('.cm-composer__step', dlg).forEach((s) => { s.hidden = s.dataset.step !== step; });
    const back = $('[data-cm-composer-back]', dlg); if (back) back.hidden = step === 'pick';
    const title = $('.cm-dialog__title', dlg); if (title) title.textContent = step === 'pick' ? 'New post' : 'Edit & share';
  }
  function setError(msg) { const e = $('[data-cm-error]', composer()); if (e) { e.textContent = msg || ''; e.hidden = !msg; } }
  function setProgress(pct) { const p = $('[data-cm-progress]', composer()); if (!p) return; p.hidden = pct == null; const bar = $('span', p); if (bar) bar.style.width = `${pct || 0}%`; }
  function setAspect(a) {
    C.aspect = a; C.fx = 0.5; C.fy = 0.5;
    const box = $('#cm-preview-box'); if (box) { box.dataset.aspect = a; box.style.setProperty('--fx', '50%'); box.style.setProperty('--fy', '50%'); }
    $$('[data-cm-aspect]').forEach((b) => b.classList.toggle('is-active', b.dataset.cmAspect === a));
  }
  function loadFile(file) {
    if (!file) return;
    if (!/^image\//.test(file.type) && !/\.(jpe?g|png|webp|gif|heic|heif)$/i.test(file.name)) { setError('Please choose a photo (JPG, PNG or WEBP).'); showStep('edit'); return; }
    if (file.size > 40 * 1024 * 1024) { setError('That photo is too large (max 40 MB).'); showStep('edit'); return; }
    if (C.url) URL.revokeObjectURL(C.url);
    C.file = file; C.url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => { C.img = img; C.w = img.naturalWidth; C.h = img.naturalHeight; const pv = $('#cm-preview'); if (pv) pv.src = C.url; setAspect('1:1'); setError(''); showStep('edit'); };
    img.onerror = () => { setError('This photo format can\'t be opened in your browser. Please choose a JPG or PNG.'); C.img = null; showStep('edit'); const pv = $('#cm-preview'); if (pv) pv.removeAttribute('src'); };
    img.src = C.url;
  }
  function cropRect() {
    const w = C.w, h = C.h;
    if (!w || !h) return null;
    if (C.aspect === 'orig') return { x: 0, y: 0, w, h };
    const r = C.aspect === '4:5' ? 4 / 5 : 1;
    let cw = w, ch = h;
    if (w / h > r) cw = Math.round(h * r); else ch = Math.round(w / r);
    return { x: Math.round((w - cw) * C.fx), y: Math.round((h - ch) * C.fy), w: cw, h: ch };
  }
  function renderBlob() {
    return new Promise((resolve, reject) => {
      const rect = cropRect(); if (!rect || !C.img) { reject(new Error('Please choose a photo first')); return; }
      const MAX = 1600;
      const scale = Math.min(1, MAX / Math.max(rect.w, rect.h));
      const canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(rect.w * scale)); canvas.height = Math.max(1, Math.round(rect.h * scale));
      const ctx = canvas.getContext('2d');
      ctx.fillStyle = '#000'; ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(C.img, rect.x, rect.y, rect.w, rect.h, 0, 0, canvas.width, canvas.height);
      canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new Error('Could not process the photo'))), 'image/jpeg', 0.88);
    });
  }
  function uploadPost(form) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', `${API}/posts`);
      xhr.setRequestHeader('X-Community-Token', (CFG.customer && CFG.customer.token) || '');
      xhr.upload.onprogress = (e) => { if (e.lengthComputable) setProgress(Math.round((e.loaded / e.total) * 90)); };
      xhr.onload = () => {
        let data = null; try { data = JSON.parse(xhr.responseText); } catch (e) { /* ignore */ }
        if (xhr.status >= 200 && xhr.status < 300 && data && data.ok) resolve(data);
        else reject(Object.assign(new Error((data && data.message) || `Upload failed (${xhr.status})`), { code: data && data.error }));
      };
      xhr.onerror = () => reject(new Error('Network error — please try again'));
      xhr.send(form);
    });
  }
  async function submitComposer(e) {
    e.preventDefault();
    if (C.uploading) return;
    if (!requireLogin()) return;
    const dlg = composer();
    if (!C.img) { setError('Please choose a photo first.'); return; }
    const btn = $('#cm-submit', dlg);
    C.uploading = true; btn.disabled = true; btn.textContent = 'Sharing…'; setError(''); setProgress(2);
    try {
      const blob = await renderBlob();
      const fd = new FormData();
      fd.append('image', blob, 'watch.jpg');
      fd.append('caption', ($('#cm-caption', dlg).value || '').trim());
      const sel = $('#cm-model', dlg); const opt = sel && sel.selectedOptions[0];
      let model = ''; let productId = '';
      if (sel && sel.value === 'other') model = ($('#cm-model-other', dlg).value || '').trim();
      else if (sel && sel.value) { model = opt.dataset.title || opt.textContent.trim(); productId = sel.value; }
      fd.append('watch_model', model);
      fd.append('product_id', productId);
      const r = await uploadPost(fd);
      setProgress(100);
      dlg.close();
      toast(r.message || 'Posted!');
      if (r.post && r.post.published) await reloadFeed({ post: Object.assign({ caption: fd.get('caption'), watchModel: fd.get('watch_model') }, r.post) });
    } catch (err) {
      setError(err.message || 'Something went wrong');
      if (err.code === 'session_expired') setTimeout(() => location.reload(), 1200);
    } finally {
      C.uploading = false; btn.disabled = false; btn.textContent = 'Share'; setProgress(null);
    }
  }
  function setupComposer() {
    const dlg = composer(); if (!dlg) return;
    const form = $('#cm-composer-form', dlg);
    form.addEventListener('submit', submitComposer);
    const file = $('#cm-file', dlg);
    file.addEventListener('change', () => loadFile(file.files && file.files[0]));
    const drop = $('.cm-drop', dlg);
    ['dragenter', 'dragover'].forEach((ev) => drop.addEventListener(ev, (e) => { e.preventDefault(); drop.classList.add('is-over'); }));
    ['dragleave', 'drop'].forEach((ev) => drop.addEventListener(ev, (e) => { e.preventDefault(); drop.classList.remove('is-over'); }));
    drop.addEventListener('drop', (e) => { const f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]; if (f) loadFile(f); });
    const cap = $('#cm-caption', dlg); const cnt = $('[data-cm-count]', dlg);
    cap.addEventListener('input', () => { if (cnt) cnt.textContent = String(cap.value.length).replace(/\B(?=(\d{3})+(?!\d))/g, ','); });
    const sel = $('#cm-model', dlg); const other = $('[data-cm-other]', dlg);
    sel.addEventListener('change', () => { other.hidden = sel.value !== 'other'; if (sel.value === 'other') $('#cm-model-other', dlg).focus(); });
    // drag to reframe
    const box = $('#cm-preview-box', dlg);
    let drag = null;
    box.addEventListener('pointerdown', (e) => { if (C.aspect === 'orig' || !C.img) return; drag = { x: e.clientX, y: e.clientY, fx: C.fx, fy: C.fy }; box.setPointerCapture(e.pointerId); });
    box.addEventListener('pointermove', (e) => {
      if (!drag) return;
      const rect = cropRect(); if (!rect) return;
      const bw = box.clientWidth, bh = box.clientHeight;
      const overflowX = (C.w - rect.w) * (bw / rect.w); const overflowY = (C.h - rect.h) * (bh / rect.h);
      if (overflowX > 0) C.fx = Math.min(1, Math.max(0, drag.fx - (e.clientX - drag.x) / overflowX));
      if (overflowY > 0) C.fy = Math.min(1, Math.max(0, drag.fy - (e.clientY - drag.y) / overflowY));
      box.style.setProperty('--fx', `${C.fx * 100}%`); box.style.setProperty('--fy', `${C.fy * 100}%`);
    });
    ['pointerup', 'pointercancel'].forEach((ev) => box.addEventListener(ev, () => { drag = null; }));
    dlg.addEventListener('close', () => { lockScroll(false); if (C.url) { URL.revokeObjectURL(C.url); C.url = null; } });
    dlg.addEventListener('click', (e) => { if (e.target === dlg && !C.uploading) dlg.close(); });
  }

  /* ---------- post bindings (modal + article page) ---------- */
  function updateCommentCount(id, n) {
    $$(`[data-id="${id}"]`).forEach((el) => {
      el.dataset.comments = String(n);
      $$('[data-cm-comment-count]', el).forEach((c) => { c.textContent = String(n); });
      const link = $('.cm-card__comments', el);
      if (link) link.textContent = n > 0 ? (n === 1 ? 'View 1 comment' : `View all ${n} comments`) : 'Add a comment…';
    });
  }
  function commentNode(name, text) {
    const li = document.createElement('li');
    li.className = 'cm-comment is-pending';
    li.innerHTML = `<span class="cm-avatar cm-avatar--sm" aria-hidden="true">${esc((name || 'Y')[0].toUpperCase())}</span><div class="cm-comment__body"><b>${esc(name || 'You')}</b> <span class="cm-comment__text">${esc(text).replace(/\n/g, '<br>')}</span><time class="cm-post__time">posting…</time></div>`;
    return li;
  }
  function autosize(ta) { ta.style.height = 'auto'; ta.style.height = `${Math.min(120, ta.scrollHeight)}px`; }
  function bindPost(root) {
    const id = root.dataset.id;
    const form = $('#cm-comment-form', root);
    if (form) {
      const ta = $('textarea', form); const btn = $('button[type="submit"]', form);
      ta.addEventListener('input', () => { btn.disabled = !ta.value.trim(); autosize(ta); });
      ta.addEventListener('keydown', (e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); if (!btn.disabled) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); } });
      form.addEventListener('submit', () => {
        // Native submission on purpose: Shopify's spam protection attaches its CAPTCHA token only to a real
        // form submit (fetch() gets "Missing CAPTCHA token"). Shopify then redirects back to the post with the
        // new comment, or with form.posted_successfully? on moderated blogs (see init()).
        const text = ta.value.trim();
        if (!text) return;
        btn.disabled = true; btn.textContent = 'Posting…';
        const pending = commentNode(CFG.customer && CFG.customer.name, text);
        const list = $('#cm-comments', root); if (list) list.appendChild(pending);
        const empty = $('[data-cm-no-comments]', root); if (empty) empty.hidden = true;
      });
    }
    const media = $('[data-cm-media]', root);
    if (media) media.addEventListener('click', () => { const now = Date.now(); if (now - S.lastTap < 320 && S.tapId === id) { S.lastTap = 0; toggleLike(id, true); } else { S.lastTap = now; S.tapId = id; } });
  }

  /* ---------- global click handling ---------- */
  function closeMenus(except) { $$('.cm-menu__list').forEach((m) => { if (m !== except) { m.hidden = true; const b = m.parentElement && $('[data-cm-menu]', m.parentElement); if (b) b.setAttribute('aria-expanded', 'false'); } }); }
  function postCtx(t) { return t.closest('.cm-card, .cm-post'); }

  document.addEventListener('click', async (e) => {
    const t = e.target.closest('[data-cm],[data-cm-like],[data-cm-open],[data-cm-share],[data-cm-close],[data-cm-view],[data-cm-more],[data-cm-share-to],[data-cm-menu],[data-cm-copy],[data-cm-delete-post],[data-cm-delete-comment],[data-cm-focus-comment],[data-cm-aspect],[data-cm-composer-back]');
    if (!t) { closeMenus(); return; }
    if (t.hasAttribute('data-cm-menu')) { const list = t.nextElementSibling; closeMenus(list); list.hidden = !list.hidden; t.setAttribute('aria-expanded', String(!list.hidden)); return; }
    closeMenus();
    if (t.dataset.cm === 'open-composer') { e.preventDefault(); openComposer(); return; }
    if (t.hasAttribute('data-cm-close')) { const d = t.closest('dialog'); if (d) d.close(); return; }
    if (t.hasAttribute('data-cm-view')) { setView(t.dataset.cmView, true); return; }
    if (t.hasAttribute('data-cm-aspect')) { setAspect(t.dataset.cmAspect); return; }
    if (t.hasAttribute('data-cm-composer-back')) { showStep('pick'); return; }
    if (t.hasAttribute('data-cm-more')) { const cap = t.closest('[data-cm-caption]'); if (cap) cap.classList.add('is-expanded'); return; }
    const ctx = postCtx(t);
    if (t.hasAttribute('data-cm-like')) { if (ctx) toggleLike(ctx.dataset.id); return; }
    if (t.hasAttribute('data-cm-share')) { if (ctx) share(ctx.dataset.url, ctx.dataset.title); return; }
    if (t.hasAttribute('data-cm-copy')) { if (ctx) copyText(new URL(ctx.dataset.url, location.origin).toString()); return; }
    if (t.hasAttribute('data-cm-share-to')) {
      const dlg = t.closest('dialog');
      if (t.dataset.cmShareTo === 'copy') { e.preventDefault(); copyText(dlg.dataset.url || location.href); dlg.close(); }
      else setTimeout(() => dlg.close(), 150);
      return;
    }
    if (t.hasAttribute('data-cm-focus-comment')) { const ta = ctx && $('#cm-comment-form textarea', ctx); if (ta) ta.focus(); else if (!loggedIn()) requireLogin(); return; }
    if (t.hasAttribute('data-cm-delete-post')) {
      if (!ctx || !window.confirm('Delete this post? This cannot be undone.')) return;
      try { await api(`/posts/${ctx.dataset.id}`, { method: 'DELETE' }); toast('Post deleted'); const card = $(`.cm-card[data-id="${ctx.dataset.id}"]`); if (card) card.remove(); if ($('#cm-post-dialog') && $('#cm-post-dialog').open) closePost(); else location.href = CFG.blogUrl; }
      catch (err) { toast(err.message || 'Could not delete post', 'error'); }
      return;
    }
    if (t.hasAttribute('data-cm-delete-comment')) {
      const li = t.closest('.cm-comment'); if (!li || !window.confirm('Delete your comment?')) return;
      try { await api(`/comments/${li.dataset.id}`, { method: 'DELETE' }); li.remove(); const list = ctx && $('#cm-comments', ctx); const n = list ? $$('.cm-comment', list).length : 0; if (list) list.dataset.count = String(n); updateCommentCount(ctx.dataset.id, n); if (n === 0) { const empty = $('[data-cm-no-comments]', ctx); if (empty) empty.hidden = false; } toast('Comment deleted'); }
      catch (err) { toast(err.message || 'Could not delete comment', 'error'); }
      return;
    }
    if (t.hasAttribute('data-cm-open')) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;
      e.preventDefault();
      if (!ctx) return;
      const url = ctx.dataset.url; const id = ctx.dataset.id;
      const isMedia = t.classList.contains('cm-card__media');
      const focusComment = !isMedia && !t.classList.contains('cm-card__comments') && t.tagName === 'BUTTON';
      if (isMedia && feedEl && feedEl.dataset.view === 'feed') {
        const now = Date.now();
        if (now - S.lastTap < 320 && S.tapId === id) { clearTimeout(S.tapTimer); S.lastTap = 0; toggleLike(id, true); return; }
        S.lastTap = now; S.tapId = id;
        clearTimeout(S.tapTimer); S.tapTimer = setTimeout(() => openPost(url), 330);
        return;
      }
      openPost(url, { focusComment });
    }
  });

  /* ---------- dialogs: backdrop + history ---------- */
  function setupDialogs() {
    const post = $('#cm-post-dialog');
    if (post) {
      post.addEventListener('click', (e) => { if (e.target === post) post.close(); });
      post.addEventListener('close', () => { lockScroll(false); $('#cm-post-dialog-body').innerHTML = ''; if (S.pushed) { S.pushed = false; history.back(); } });
    }
    ['#cm-share', '#cm-login'].forEach((sel) => { const d = $(sel); if (d) d.addEventListener('click', (e) => { if (e.target === d) d.close(); }); });
    window.addEventListener('popstate', (e) => {
      const dlg = $('#cm-post-dialog');
      if (dlg && dlg.open) { S.pushed = false; dlg.close(); }
      else if (e.state && e.state.cmPost) { openPost(e.state.cmPost, { fromHistory: true }); S.pushed = true; }
    });
  }

  /* ---------- init ---------- */
  function init() {
    refreshTimes(document);
    setInterval(() => refreshTimes(document), 60000);
    if (feedEl) {
      let v = feedEl.dataset.view || 'grid';
      try { v = localStorage.getItem('cm-view') || v; } catch (e) { /* ignore */ }
      setView(v, false);
      setupInfinite();
      setupComposer();
      if (location.hash === '#share') { history.replaceState(null, '', location.pathname + location.search); setTimeout(openComposer, 150); }
      syncLikes(feedEl);
    }
    const page = $('.shopify-section--community-post #cm-post');
    if (page) { bindPost(page); syncLikes(page); }
    if ($('[data-cm-posted]')) toast(CFG.moderated ? 'Thanks! Your comment will appear once approved.' : 'Comment posted');
    if ($('[data-cm-comment-error]') && $('[data-cm-comment-error]').textContent.trim()) toast($('[data-cm-comment-error]').textContent.trim(), 'error');
    setupDialogs();
    // Logged in: refresh the liked list from the API so hearts are right even if Shopify served cached HTML.
    if (loggedIn()) { api('/me').then((r) => { if (r && Array.isArray(r.liked)) { r.liked.forEach((id) => S.liked.add(String(id))); syncLikes(document); } }).catch(() => { /* ignore */ }); }
    window.addEventListener('resize', () => initCaptions(document));
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => initCaptions(document)); else initCaptions(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
